// extracted by mini-css-extract-plugin
export default {"container":"BackgroundPage_container__vTDV2"};